import { Route } from "react-router-dom";
import AffiliateReportScreen from "../../../container/Affiliate/AffiliateReportScreen";
import { APP_URLS } from "../../../utils/constant";

const AffiliateReportRoutes = (access = {}) => {
  const { view = false } = access || {};

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.AFFILIATE_REPORT.HOME}
          element={<AffiliateReportScreen screenPermissions={access} />}
        />
      )}
    </>
  );
};

export default AffiliateReportRoutes;
